<template>
  <div class="c-services component">
    <h3 class="text-upper">SERWIS</h3>
    <div class="flex-row">
      <div class="flex-col mt--1 mb--2">
        <SelectInput class="v-brand__select" :selectedValue="getSelectedDealer ? getSelectedDealer.name : null">
          <ul slot="list">
            <li><strong>Serwis mechaniczny</strong></li>
            <li v-for="dealer in getDealers" v-on:click="
              lead.dealer_id = dealer.id;
            fetchTerms();
            addminssionTermsLoading = true;
            sendPIXEL('select_dealer_from_input', dealer.id);
              ">
              {{ dealer.name }} ({{ dealer.city }})
            </li>
          </ul>
        </SelectInput>
      </div>
    </div>

    <h3 class="text-upper">Preferowany termin</h3>
    <div class="flex-row">
      <div class="flex-col mt--2 mb--2">
        <span class="label">Data przyjęcia</span>
        <template v-if="lead.dealer_id == '' || lead.services_val.length == 0">
          <br />
          <span class="text-alert">Proszę wybrać usługę oraz serwis.</span>
        </template>
        <template v-else>
          <br />
          <label>
            <input type="checkbox" name="date_mode" v-model="lead.visit_date_val" v-on:click="
              lead.date_from = nextDay;
            lead.date_hour_from = nextTime;
            lead.hour_from = null;
            " :true-value="false" :false-value="true" />
            Możliwie najszybciej
          </label>
          <br />
          <label>
            <input type="checkbox" name="date_mode" v-model="lead.visit_date_val" :true-value="true"
              :false-value="false" />
            Wizyty od
          </label>
          <div class="flex-col">
            <date-picker v-model="lead.date_from" valueType="format" :lang="getDetepickerConfig"
              v-if="lead.visit_date_val === true" :disabled-date="getDetepickerConfig.range"></date-picker>
          </div>
        </template>
      </div>
      <div class="flex-col mt--2 mb--2">
        <span class="label">Godzina przyjęcia</span>
        <br />
        <label v-if="!lead.visit_date_val">
          <input type="radio" name="date_time" :value="getTimeOfDayWithDealersHours[0].val"
            v-model="lead.visit_hour_val" v-on:click="
              lead = {
                ...lead,
                date_hour_from: nextTime,
                hour_to: getTimeOfDayWithDealersHours[0].term.hour_to,
                visit_hour_name: getTimeOfDayWithDealersHours[0].name,
              }
              " />
          {{ getTimeOfDay[0].name }}
          <br />
        </label>
        <label v-for="timeOfDay in getTimeOfDayWithDealersHours"
          v-if="(!lead.visit_date_val && timeOfDay.val != 1) || lead.visit_date_val">
          <input type="radio" name="date_time" :value="timeOfDay.val" v-model="lead.visit_hour_val" v-on:click="
            lead = { ...lead, ...timeOfDay.term, visit_hour_name: timeOfDay.name }
            " />
          {{ timeOfDay.name }}
          <br />
        </label>
      </div>
    </div>

    <h3 class="text-upper">DALSZE OPCJE</h3>
    <div class="flex-row">
      <div class="flex-col">
        <template v-for=" additionalOption in getAdditionalOptions">
          <label class="mt--2">
            <input type="checkbox" :value="additionalOption.val" v-on:click="pushAdditionalOption(additionalOption)"
              :disabled="disableAddtionalOptions.includes(additionalOption.id) || (additionalOption.disableVar && additionalOption.disableVar())" />
            {{ additionalOption.name }}
            <br />
          </label>
        <SelectInput class="v-brand__select" :selectedValue="lead.subAdditionalOptions.filter( e =>  additionalOption.subOptions.includes(e))" v-if="additionalOption.subOptions && lead.additional_options_val.includes(additionalOption.val)">
          <ul slot="list">
            <li v-for="subOption in additionalOption.subOptions" v-on:click="toggleSubOption(subOption)">
              {{ subOption }}
            </li>
          </ul>
        </SelectInput>
        </template>
        <span class="text-alert" v-if="lead.additional_options_val.length < 1"><br>Proszę wybrać opcje.</span>
        <em
          v-if="lead.additional_options_val.includes('Serwis 24 - oddaj auto o wybranej godzinie, Odbierz następnego dnia o 10:00')">W
          przypadku zostawienia samochodu w sobotę - odbiór w
          poniedziałek.</em>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

import lead from "@/mixins/lead.js";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import TypeSelect from '../elements/type-select.vue'

export default {
  data() {
    return {
      selectedDate: null,
      disableAddtionalOptions: [],
      loading: true
    };
  },
  components: {
    DatePicker,
    TypeSelect
  },
  computed: {
    ...mapGetters({
      getTimeOfDay: "definitions/getTimeOfDay",
      getDealers: "definitions/getDealers",
      getReplacementCars: "definitions/getReplacementCars",
      getDetepickerConfig: "definitions/getDetepickerConfig",
      getTimeOfDayWithDealersHours: "definitions/getTimeOfDayWithDealersHours",
      getAvaibleDatesByTerms: "definitions/getAvaibleDatesByTerms",
      getAvailableTermsByDay: "definitions/getAvailableTermsByDay",
    }),
    getSelectedDealer() {
      return this.getDealers.find((e) => e.id == this.lead.dealer_id);
    },
  },
  mixins: [lead],
  methods: {
    ...mapActions({
      fetchDealers: "definitions/fetchDealers",
      fetchServiceCars: "definitions/fetchServiceCars",
      fetchServiceAdmissionTerms: "definitions/fetchServiceAdmissionTerms",
    }),
    pushAdditionalOption(additionalOption) {
        if (additionalOption.val == "Potrzebuje mobilności") {
            this.lead.replacement_car = 1;
            this.fetchServiceCars();
        }

        const allOptions = this.$store.getters['definitions/getAdditionalOptions'] || [];
        let id = this.lead.additional_options_val.indexOf(additionalOption.val);

        if (id != -1) {
            this.lead.additional_options_val.splice(id, 1);
            if (additionalOption.disable) {
                this.disableAddtionalOptions = [];
            }
        } else {
            this.lead.additional_options_val.push(additionalOption.val);

            if (additionalOption.disable) {
                this.disableAddtionalOptions = [...additionalOption.disable];
            }

            this.lead.additional_options_val = this.lead.additional_options_val.filter(val => {
                const def = allOptions.find(o => o.val === val);
                if (!def) return true;

                const isConflicted = additionalOption.disable && additionalOption.disable.includes(def.id);
                const isDisabledByLogic = def.disableVar && def.disableVar();

                return !isConflicted && !isDisabledByLogic;
            });

            if (additionalOption.default) {
              
                var defaults = {};
                if (additionalOption.default) {
                    defaults = additionalOption.default;
                }

                this.lead = {
                    ...this.lead,
                    ...defaults,
                };
            }
        }
    },
    toggleSubOption(val) {
      if (!this.lead.subAdditionalOptions) {
        this.lead.subAdditionalOptions = [];
      }

      const index = this.lead.subAdditionalOptions.indexOf(val);

      if (index === -1) {
        this.lead.subAdditionalOptions.push(val);
      } else {
        this.lead.subAdditionalOptions.splice(index, 1);
      }

      this.lead = { ...this.lead };
    },
    sendPIXEL(event, value) {
      if (typeof fbq !== "undefined") {
        fbq("trackCustom", event, { dealer_id: value });
      } else {
        console.log("FB pixel not found");
      }
    },
  },
  mounted() {
    this.fetchDealers();
    this.lead.date = null;
    this.lead.hour = null;
    this.lead.advisor_id = null;
    this.lead.term_key = null;
    this.lead.repair = null;
    this.lead.mechanic_id = null;
    this.lead.mechanic_hour = null;
    this.lead.mechanic_time = null;
    this.lead.date_from = null;
    this.lead.date_from = null;
    this.lead.days = null;
    this.lead.hour_from = null;
    this.lead.hour_to = null;
    this.lead.date_hour_from = null;
    // this.lead.dealer_id = null;
    this.lead.mechanic_offset_max = null;
    this.lead.mechanic_next_day_hour = null;
    this.lead.date_hour_from = this.nextTime;
  },
};
</script>
<style lang="scss">
.text-alert {
  color: #ffad1f;
}
</style>
